/**
 * IUSAC Vehicle Photos Gallery - Swiper Integration + Fancybox
 * Galeria zdjęć pojazdu z głównym sliderem i miniaturkami
 */

const initVehicleGallery = function() {
    const galleryContainers = document.querySelectorAll('.iusac-vehicle-gallery-container');

    if (!galleryContainers.length) {
        return;
    }

    galleryContainers.forEach(container => {
        const thumbsSlider = container.querySelector('.iusac-gallery-thumbs');
        const mainSlider = container.querySelector('.iusac-gallery-main');

        if (!thumbsSlider || !mainSlider) {
            console.error('Vehicle Gallery: Brak wymaganych elementów slidera');
            return;
        }

        // Inicjalizacja slidera z miniaturkami
        const swiperThumbs = new Swiper(thumbsSlider, {
            spaceBetween: 10,
            slidesPerView: 6,
            watchSlidesProgress: true,
            breakpoints: {
                320: {
                    slidesPerView: 3,
                    spaceBetween: 5
                },
                480: {
                    slidesPerView: 4,
                    spaceBetween: 8
                },
                768: {
                    slidesPerView: 5,
                    spaceBetween: 10
                },
                1024: {
                    slidesPerView: 6,
                    spaceBetween: 10
                }
            }
        });

        // Inicjalizacja głównego slidera - PROSTY CONFIG BEZ PIERDÓŁ
        const swiperMain = new Swiper(mainSlider, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true, // WŁĄCZ PĘTLĘ
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: swiperThumbs
            }
        });

        // FANCYBOX
        if (typeof Fancybox !== 'undefined') {
            const galleryImages = [];
            const mainSlides = mainSlider.querySelectorAll('.swiper-slide img');

            mainSlides.forEach((img) => {
                galleryImages.push({
                    src: img.src,
                    alt: img.alt || ''
                });
            });

            mainSlider.addEventListener('click', function(e) {
                if (e.target.closest('.swiper-button-next') || e.target.closest('.swiper-button-prev')) {
                    return;
                }

                const slide = e.target.closest('.swiper-slide');
                if (!slide) return;

                swiperMain.autoplay.stop();

                Fancybox.show(galleryImages, {
                    startIndex: swiperMain.realIndex || swiperMain.activeIndex,
                    on: {
                        close: () => {
                            swiperMain.autoplay.start();
                        }
                    }
                });
            });
        }

        console.log('Vehicle Gallery: Galeria zainicjowana');
    });
};

// Inicjalizacja
window.addEventListener('load', function() {
    setTimeout(initVehicleGallery, 100);
});

// Export
if (typeof module !== 'undefined' && module.exports) {
    module.exports = initVehicleGallery;
}